import { Expose } from "class-transformer";

export class CreateZoneDto {
  @Expose()
  name: string;

  @Expose()
  country: string;
}
